const DASHBOARD_TOUR_PENDING_EMAIL_KEY = 'arbcor_dashboard_tour_pending_email';
const DASHBOARD_TOUR_COMPLETED_PREFIX = 'arbcor_dashboard_tour_completed:';

const normalizeEmail = (email) => (typeof email === 'string' ? email.trim().toLowerCase() : '');

const getUserEmail = (user) => normalizeEmail(user?.email);

export const markDashboardTourPendingForEmail = (email) => {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return;

  try {
    localStorage.setItem(DASHBOARD_TOUR_PENDING_EMAIL_KEY, normalizedEmail);
  } catch {
    // Ignore storage errors.
  }
};

export const shouldStartDashboardTourForUser = (user) => {
  const email = getUserEmail(user);
  if (!email) return false;

  try {
    const pendingEmail = normalizeEmail(localStorage.getItem(DASHBOARD_TOUR_PENDING_EMAIL_KEY));
    if (pendingEmail !== email) return false;

    return localStorage.getItem(`${DASHBOARD_TOUR_COMPLETED_PREFIX}${email}`) !== 'true';
  } catch {
    return false;
  }
};

export const completeDashboardTourForUser = (user) => {
  const email = getUserEmail(user);
  if (!email) return;

  try {
    localStorage.setItem(`${DASHBOARD_TOUR_COMPLETED_PREFIX}${email}`, 'true');

    const pendingEmail = normalizeEmail(localStorage.getItem(DASHBOARD_TOUR_PENDING_EMAIL_KEY));
    if (pendingEmail === email) {
      localStorage.removeItem(DASHBOARD_TOUR_PENDING_EMAIL_KEY);
    }
  } catch {
    // Ignore storage errors.
  }
};

export const resetDashboardTourForUser = (user) => {
  const email = getUserEmail(user);
  if (!email) return;

  try {
    localStorage.removeItem(`${DASHBOARD_TOUR_COMPLETED_PREFIX}${email}`);
    localStorage.setItem(DASHBOARD_TOUR_PENDING_EMAIL_KEY, email);
  } catch {
    // Ignore storage errors.
  }
};
